import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { CourseFilterCheckboxGroup } from './CourseFilterCheckboxGroup'
import { FilterDrawerType, FilterType, ProgressFilterValue } from './types'
import { CourseFilterAccordion } from '../CourseFilterAccordion/CourseFilterAccordion'

type Props = {
  type: FilterDrawerType
  onChange: (filterType: FilterType, value: ProgressFilterValue) => void
}

export const CourseFilterProgress = ({ type, onChange }: Props) => {
  const { t } = useTranslation()

  const filters = useAppSelector((state) => createFiltersSelector(state, type))

  return (
    <CourseFilterAccordion
      title={t('coursesFilterDrawer.courseProgress')}
      badgeCount={filters.courseProgress.length}
      testId="course-filter-progress"
    >
      <CourseFilterCheckboxGroup<ProgressFilterValue>
        filterType="courseProgress"
        options={[
          { label: t('coursesFilterDrawer.notStarted'), value: ProgressFilterValue.NOT_STARTED },
          { label: t('coursesFilterDrawer.inProgress'), value: ProgressFilterValue.IN_PROGRESS },
          { label: t('coursesFilterDrawer.completed'), value: ProgressFilterValue.COMPLETED },
        ]}
        filters={filters}
        onChange={onChange}
      />
    </CourseFilterAccordion>
  )
}
